<template>
  <div>
    <vs-row vs-type="flex" vs-justify="space-between">
      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="12" class="m-3" >  
         <a class="text-primary" href="#" @click.prevent="backToStatement()">{{ $t('MRMR.Statement.BackToStatement')}}</a>
      </vs-col>
   </vs-row>
    <div class="powerBiContainer">
      <div id="reportContainer" />
    </div>
  </div>
</template>

<script>
import { service, factories, models } from "powerbi-client";

export default {
  data() {
    return {
      props: {
        msg: String
      }
    };
  },
  mounted() {
    this.$auth.getPowerBiToken().then(
      token => {
        this.$powerBiApi.get("/myorg/groups/" + this.$store.state.powerbiConfigurations.mrmrGroupId + "/reports/" + this.$store.state.powerbiConfigurations.mrmrComparison).then(
          response => {
            const statementAFilter = {
              $schema: "http://powerbi.com/product/schema#basic",
              target: {
                table: "StatementA",
                column: "MRMRStatementHeaderId"
              },
              operator: "In",
              values: [this.$route.query.statementAId],
              filterType: 1 // pbi.models.FilterType.BasicFilter
            }

            const statementBFilter = {
              $schema: "http://powerbi.com/product/schema#basic",
              target: {
                table: "StatementB",
                column: "MRMRStatementHeaderId"
              },
              operator: "In",
              values: [this.$route.query.statementBId],
              filterType: 1 // pbi.models.FilterType.BasicFilter
            }

            const config = {
              type: "report",
              tokenType: models.TokenType.Aad,
              accessToken: token.accessToken,
              embedUrl: response.data.embedUrl,
              id: this.$store.state.powerbiConfigurations.mrmrComparison,
              permissions: models.Permissions.All,
              settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: true
              },
              filters: [statementAFilter, statementBFilter]  
            };

            const powerbi = new service.Service(
              factories.hpmFactory,
              factories.wpmpFactory,
              factories.routerFactory
            );

            const reportContainer = document.getElementById("reportContainer");
            const report = powerbi.embed(reportContainer, config);

            // Report.off removes a given event handler if it exists.
            report.off("loaded");

            // Report.on will add an event handler which prints to Log window.
            report.on("loaded", function () {
              console.log("Loaded");
            });

            // Report.off removes a given event handler if it exists.
            report.off("rendered");

            // Report.on will add an event handler which prints to Log window.
            report.on("rendered", function () {
              console.log("Rendered");
            });

            report.on("error", function (event) {
              console.log(event.detail);
              report.off("error");
            });

            report.off("saved");
            report.on("saved", function (event) {
              if (event.detail.saveAs) {
                console.log(
                  "In order to interact with the new report, create a new token and load the new report"
                );
              }
            });
          }
        );
      }
    );
  },
  methods: {
    backToStatement() {
      if (this.$route.query.readOnly) {
        this.$router.push({
          name: "mrmr-statements-view",
          query: { id: this.$route.query.statementAId }
        });
      } else {
        this.$router.push({
          name: "mrmr-statements-edit",
          query: { id: this.$route.query.statementAId }
        });
      }
     
    }
  }
};
</script>
<style lang="scss">
  #reportContainer {
    width: 100%;
    height: 600px;
  }

</style>
